module.exports = __webpack_public_path__ + "static/media/apps.ff5b53e1.svg";